/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./resources/app.ts":
/*!**************************!*\
  !*** ./resources/app.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _scripts_components_Consent_Consent__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./scripts/components/Consent/Consent */ "./resources/scripts/components/Consent/Consent.ts");
/* harmony import */ var _scripts_components_Anyday_Anyday__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./scripts/components/Anyday/Anyday */ "./resources/scripts/components/Anyday/Anyday.ts");
/* harmony import */ var _scripts_components_Geolocator_Geolocator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./scripts/components/Geolocator/Geolocator */ "./resources/scripts/components/Geolocator/Geolocator.ts");
/* harmony import */ var _scripts_components_MultistoreSwitcher_MultistoreSwitcher__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./scripts/components/MultistoreSwitcher/MultistoreSwitcher */ "./resources/scripts/components/MultistoreSwitcher/MultistoreSwitcher.ts");
/* harmony import */ var _scripts_components_Video_Video__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./scripts/components/Video/Video */ "./resources/scripts/components/Video/Video.ts");
/* harmony import */ var _scripts_components_OptionFieldsets_OptionFieldsets__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./scripts/components/OptionFieldsets/OptionFieldsets */ "./resources/scripts/components/OptionFieldsets/OptionFieldsets.ts");
/* harmony import */ var _scripts_components_ShowMoreVariants_ShowMoreVariants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./scripts/components/ShowMoreVariants/ShowMoreVariants */ "./resources/scripts/components/ShowMoreVariants/ShowMoreVariants.ts");
/* harmony import */ var _scripts_components_CartGroupRemove_CartGroupRemove__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./scripts/components/CartGroupRemove/CartGroupRemove */ "./resources/scripts/components/CartGroupRemove/CartGroupRemove.ts");
/* harmony import */ var _scripts_components_Slider_Slider__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./scripts/components/Slider/Slider */ "./resources/scripts/components/Slider/Slider.ts");









customElements.define('option-fieldsets', _scripts_components_OptionFieldsets_OptionFieldsets__WEBPACK_IMPORTED_MODULE_0__["default"]);
customElements.define('video-component', _scripts_components_Video_Video__WEBPACK_IMPORTED_MODULE_1__["default"]);
customElements.define('multistore-switcher', _scripts_components_MultistoreSwitcher_MultistoreSwitcher__WEBPACK_IMPORTED_MODULE_2__["default"]);
customElements.define('geolocator-component', _scripts_components_Geolocator_Geolocator__WEBPACK_IMPORTED_MODULE_3__["default"]);
customElements.define('edition-anyday', _scripts_components_Anyday_Anyday__WEBPACK_IMPORTED_MODULE_4__["default"]);
customElements.define('show-more-variants', _scripts_components_ShowMoreVariants_ShowMoreVariants__WEBPACK_IMPORTED_MODULE_5__["default"]);
customElements.define('cart-group-remove', _scripts_components_CartGroupRemove_CartGroupRemove__WEBPACK_IMPORTED_MODULE_6__["default"]);
customElements.define('slider-section', _scripts_components_Slider_Slider__WEBPACK_IMPORTED_MODULE_7__["default"]);
var consent = new _scripts_components_Consent_Consent__WEBPACK_IMPORTED_MODULE_8__["default"]();
consent.init();

/***/ }),

/***/ "./resources/scripts/components/Anyday/Anyday.ts":
/*!*******************************************************!*\
  !*** ./resources/scripts/components/Anyday/Anyday.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Anyday)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var Anyday = /*#__PURE__*/function (_HTMLElement) {
  function Anyday() {
    var _this;
    _classCallCheck(this, Anyday);
    _this = _callSuper(this, Anyday);
    _this.openModal = _this.openModal.bind(_this);
    _this.closeModal = _this.closeModal.bind(_this);
    _this.getContentFromSection = _this.getContentFromSection.bind(_this);
    _this.handleSelection = _this.handleSelection.bind(_this);
    return _this;
  }
  _inherits(Anyday, _HTMLElement);
  return _createClass(Anyday, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.addEventListener('click', this.openModal);
    }
  }, {
    key: "reInitEvents",
    value: function reInitEvents() {
      var _this2 = this;
      var closeBtn = document.querySelector('.anyday-dialog-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', this.closeModal);
      }
      var options = document.querySelectorAll('.anyday-payment-option');
      options.forEach(function (option) {
        option.addEventListener('click', function () {
          _this2.handleSelection(options, option);
        });
      });
    }
  }, {
    key: "openModal",
    value: function openModal() {
      this.getContentFromSection();
      var anydayOverlay = document.querySelector('.anyday-overlay-mask');
      var anydayModal = document.querySelector('.anyday-dialog-box');
      if (anydayOverlay) {
        anydayOverlay.style.zIndex = '9999';
        anydayOverlay.classList.add('anyday-overlay-active');
      }
      if (anydayModal) {
        anydayModal.classList.add('anyday-show');
      }
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "closeModal",
    value: function closeModal() {
      var anydayOverlay = document.querySelector('.anyday-overlay-mask');
      var anydayModal = document.querySelector('.anyday-dialog-box');
      if (anydayOverlay) {
        anydayOverlay.style.zIndex = '-1';
        anydayOverlay.classList.remove('anyday-overlay-active');
      }
      if (anydayModal) {
        anydayModal.classList.remove('anyday-show');
      }
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "handleSelection",
    value: function handleSelection(options, option) {
      options.forEach(function (opt) {
        opt.classList.remove('anyday-payment-option-selected');
      });
      option.classList.add('anyday-payment-option-selected');
    }
  }, {
    key: "getContentFromSection",
    value: function () {
      var _getContentFromSection = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var url, response, responseText, fresh, selectorElement, freshContent, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              // eslint-disable-next-line prefer-destructuring
              url = this.dataset.url;
              _context.p = 1;
              _context.n = 2;
              return window.fetch("".concat(url, "?section_id=anyday"));
            case 2:
              response = _context.v;
              if (!response.ok) {
                _context.n = 5;
                break;
              }
              _context.n = 3;
              return response.text();
            case 3:
              responseText = _context.v;
              fresh = document.createElement('div');
              fresh.innerHTML = responseText;
              selectorElement = document.querySelector('[data-anyday-content]');
              freshContent = fresh.querySelector('[data-anyday-content]');
              if (!(selectorElement && freshContent)) {
                _context.n = 5;
                break;
              }
              if (!(selectorElement.innerHTML === freshContent.innerHTML)) {
                _context.n = 4;
                break;
              }
              return _context.a(2);
            case 4:
              selectorElement.innerHTML = freshContent.innerHTML;
            case 5:
              _context.n = 7;
              break;
            case 6:
              _context.p = 6;
              _t = _context.v;
              _t.log(_t);
            case 7:
              _context.p = 7;
              this.reInitEvents();
              return _context.f(7);
            case 8:
              return _context.a(2);
          }
        }, _callee, this, [[1, 6, 7, 8]]);
      }));
      function getContentFromSection() {
        return _getContentFromSection.apply(this, arguments);
      }
      return getContentFromSection;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/CartGroupRemove/CartGroupRemove.ts":
/*!*************************************************************************!*\
  !*** ./resources/scripts/components/CartGroupRemove/CartGroupRemove.ts ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CartGroupRemove)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CartGroupRemove = /*#__PURE__*/function (_HTMLElement) {
  function CartGroupRemove() {
    var _this;
    _classCallCheck(this, CartGroupRemove);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CartGroupRemove, [].concat(args));
    _defineProperty(_this, "busy", false);
    _defineProperty(_this, "triggerEl", null);
    return _this;
  }
  _inherits(CartGroupRemove, _HTMLElement);
  return _createClass(CartGroupRemove, [{
    key: "uniqId",
    get: function get() {
      return this.getAttribute('uniq-id') || this.dataset.uniqId || '';
    },
    set: function set(v) {
      if (v) this.setAttribute('uniq-id', v);else this.removeAttribute('uniq-id');
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.onClick = this.onClick.bind(this);
      this.triggerEl = this.querySelector('[data-trigger]') || this.querySelector('button, a') || this;
      this.addEventListener('click', this.onClick);
      this.syncVisibility();
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback() {
      this.syncVisibility();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }
  }, {
    key: "syncVisibility",
    value: function syncVisibility() {
      // Auto-hide if no uniq-id (you can also control visibility via Liquid)
      this.style.display = this.uniqId ? '' : 'none';
    }
  }, {
    key: "onClick",
    value: function () {
      var _onClick = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (this.contains(e.target)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              // Prevent following <a> href, etc.
              e.preventDefault();
              _context.n = 2;
              return this.removeGroup();
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function onClick(_x) {
        return _onClick.apply(this, arguments);
      }
      return onClick;
    }()
  }, {
    key: "removeGroup",
    value: function () {
      var _removeGroup = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this$uniqId, _btn$getAttribute, _btn$getAttribute2, _btn$getAttribute3, _btn$getAttribute4;
        var uniqId, confirmText, btn, prevTitle, prevAria, _cart$items, cart, keys, _iterator, _step, key, _t, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!this.busy) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              uniqId = (_this$uniqId = this.uniqId) === null || _this$uniqId === void 0 ? void 0 : _this$uniqId.trim();
              if (uniqId) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              confirmText = this.getAttribute('confirm'); // eslint-disable-next-line no-alert
              if (!(confirmText && !window.confirm(confirmText))) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2);
            case 3:
              btn = this.triggerEl;
              prevTitle = (_btn$getAttribute = btn === null || btn === void 0 || (_btn$getAttribute2 = btn.getAttribute) === null || _btn$getAttribute2 === void 0 ? void 0 : _btn$getAttribute2.call(btn, 'title')) !== null && _btn$getAttribute !== void 0 ? _btn$getAttribute : null;
              prevAria = (_btn$getAttribute3 = btn === null || btn === void 0 || (_btn$getAttribute4 = btn.getAttribute) === null || _btn$getAttribute4 === void 0 ? void 0 : _btn$getAttribute4.call(btn, 'aria-label')) !== null && _btn$getAttribute3 !== void 0 ? _btn$getAttribute3 : null;
              _context2.p = 4;
              this.busy = true;
              this.setAttribute('aria-busy', 'true');
              if (btn) {
                btn.setAttribute('aria-disabled', 'true');
                if ('disabled' in btn) btn.disabled = true;
                if (prevTitle !== null) btn.setAttribute('title', 'Fjerner…');
                if (prevAria !== null) btn.setAttribute('aria-label', 'Fjerner…');
              }
              _context2.n = 5;
              return this.getCart();
            case 5:
              cart = _context2.v;
              keys = this.getGroupKeys((_cart$items = cart.items) !== null && _cart$items !== void 0 ? _cart$items : [], uniqId);
              if (this.hasAttribute('debug')) {
                // eslint-disable-next-line no-console
                console.log('[CartGroupRemove] uniqId:', uniqId, 'keys:', keys, 'items:', cart.items);
              }
              if (keys.length) {
                _context2.n = 6;
                break;
              }
              throw new Error('Kunne ikke finde varerne i gruppen.');
            case 6:
              // Remove SEQUENTIALLY to avoid race conditions with /cart/change.js
              // eslint-disable-next-line no-restricted-syntax
              _iterator = _createForOfIteratorHelper(keys);
              _context2.p = 7;
              _iterator.s();
            case 8:
              if ((_step = _iterator.n()).done) {
                _context2.n = 10;
                break;
              }
              key = _step.value;
              _context2.n = 9;
              return this.removeByKey(key);
            case 9:
              _context2.n = 8;
              break;
            case 10:
              _context2.n = 12;
              break;
            case 11:
              _context2.p = 11;
              _t = _context2.v;
              _iterator.e(_t);
            case 12:
              _context2.p = 12;
              _iterator.f();
              return _context2.f(12);
            case 13:
              // Tell the theme to re-render the cart UI
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              // Local event hook
              this.dispatchEvent(new CustomEvent('group-removed', {
                detail: {
                  uniqId: uniqId,
                  count: keys.length
                }
              }));
              _context2.n = 15;
              break;
            case 14:
              _context2.p = 14;
              _t2 = _context2.v;
              // eslint-disable-next-line no-alert
              console.log((_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || 'Noget gik galt.');
            case 15:
              _context2.p = 15;
              this.busy = false;
              this.removeAttribute('aria-busy');
              if (btn) {
                btn.setAttribute('aria-disabled', 'false');
                if ('disabled' in btn) btn.disabled = false;
                if (prevTitle !== null) btn.setAttribute('title', prevTitle);
                if (prevAria !== null) btn.setAttribute('aria-label', prevAria);
              }
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              return _context2.f(15);
            case 16:
              return _context2.a(2);
          }
        }, _callee2, this, [[7, 11, 12, 13], [4, 14, 15, 16]]);
      }));
      function removeGroup() {
        return _removeGroup.apply(this, arguments);
      }
      return removeGroup;
    }() // Collect all keys that belong to the same package/add-on group
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "getGroupKeys",
    value: function getGroupKeys(items, uniqId) {
      // Cover underscore/hyphen + with/without 'ø'
      var CANDIDATES = new Set(['_uniq_id', '_uniq-id', '_parent_id', '_parent-id', '_tilkøb_id', '_tilkøb-id', '_tilkob_id', '_tilkob-id']);
      return items.filter(function (li) {
        var p = (li === null || li === void 0 ? void 0 : li.properties) || {};
        // eslint-disable-next-line no-restricted-syntax
        for (var _i = 0, _Object$keys = Object.keys(p); _i < _Object$keys.length; _i++) {
          var k = _Object$keys[_i];
          if (CANDIDATES.has(k) && String(p[k]) === uniqId) return true;
        }
        return false;
      }).map(function (li) {
        return li.key;
      })
      // Keep order stable but unique (just in case)
      .filter(function (k, i, arr) {
        return arr.indexOf(k) === i;
      });
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "getCart",
    value: function () {
      var _getCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return fetch('/cart.js', {
                headers: {
                  Accept: 'application/json'
                }
              });
            case 1:
              res = _context3.v;
              if (res.ok) {
                _context3.n = 2;
                break;
              }
              throw new Error('Kunne ikke hente kurv.');
            case 2:
              return _context3.a(2, res.json());
          }
        }, _callee3);
      }));
      function getCart() {
        return _getCart.apply(this, arguments);
      }
      return getCart;
    }() // eslint-disable-next-line class-methods-use-this
  }, {
    key: "removeByKey",
    value: function () {
      var _removeByKey = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(key) {
        var res, msg, _yield$res$json, _t3, _t4, _t5, _t6, _t7;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.n = 1;
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json'
                },
                body: JSON.stringify({
                  id: key,
                  quantity: 0
                })
              });
            case 1:
              res = _context4.v;
              if (res.ok) {
                _context4.n = 10;
                break;
              }
              msg = 'Kunne ikke fjerne.';
              _context4.p = 2;
              _context4.n = 3;
              return res.json();
            case 3:
              _t5 = _yield$res$json = _context4.v;
              _t4 = _t5 === null;
              if (_t4) {
                _context4.n = 4;
                break;
              }
              _t4 = _yield$res$json === void 0;
            case 4:
              if (!_t4) {
                _context4.n = 5;
                break;
              }
              _t6 = void 0;
              _context4.n = 6;
              break;
            case 5:
              _t6 = _yield$res$json.description;
            case 6:
              _t3 = _t6;
              if (_t3) {
                _context4.n = 7;
                break;
              }
              _t3 = msg;
            case 7:
              msg = _t3;
              _context4.n = 9;
              break;
            case 8:
              _context4.p = 8;
              _t7 = _context4.v;
            case 9:
              throw new Error(msg);
            case 10:
              return _context4.a(2);
          }
        }, _callee4, null, [[2, 8]]);
      }));
      function removeByKey(_x2) {
        return _removeByKey.apply(this, arguments);
      }
      return removeByKey;
    }()
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ['uniq-id'];
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/Consent/Consent.ts":
/*!*********************************************************!*\
  !*** ./resources/scripts/components/Consent/Consent.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Consent)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Consent Component
//
// This class manages user consent tracking and interaction with Shopify's consent-tracking API.
// It includes methods for initializing consent features, handling consent updates, and interacting
// with Shopify's privacy settings.
//
// Key Functionalities:
// - `init()`: Loads Shopify's consent-tracking API and initializes the consent component.
// - `initConsentComponent()`: Sets up event listeners for consent actions, such as recalling consent preferences.
// - `handleConsentUpdate(state: string)`: Updates consent settings based on the user's current preferences.
//   - Parameters:
//     - `state`: A string representing the consent state ("granted", "denied", etc.).
// - `checkConsentBannerInteraction()`: Verifies if the user has interacted with the consent banner.
// - `gtag(...args)`: Pushes consent-related events to the Google Tag Manager data layer.
// - `recallConsent()`: Displays the privacy banner to allow users to update their consent preferences.
// - `logConsent(consentSettings: object)`: Logs the user's consent preferences to a database or analytics tool.
//
// Dependencies:
// - `window.dataLayer`: Required for Google Consent Mode V2 integration.
// - Shopify Customer Privacy Banner: Must be enabled in the Shopify admin panel.
//
// Error Handling:
// - Errors in loading Shopify features (e.g., API initialization failures) are logged to the console without blocking the process.
//
// Extensibility:
// - Support additional consent categories or analytics tools by extending `handleConsentUpdate` and other methods.
// - Update `logConsent` to integrate with custom databases or third-party analytics platforms as needed.
//
// Notes:
// - Local storage is used to persist consent settings across sessions.
// - Ensure GDPR/CCPA compliance by providing legally required opt-in/opt-out functionality and transparency.
// - Refer to Shopify's privacy documentation for specific implementation requirements.
//
// Usage Example:
// 1. Import the `Consent` class and initialize it in your application:
// ---- import Consent from './scripts/components/Consent/Consent';
// ---- const consent = new Consent();
// ---- consent.init();
//
// 2. To enable the recall consent feature, add an element with the ID "recall-consent" to the DOM:
// ---- <a href="#" id="recall-consent"></a>
//
// 3. Add Locales: en: "change_cookie_settings": "Change your cookie settings", da: "change_cookie_settings": "Tilpas dine cookie-indstillinger",
var Consent = /*#__PURE__*/function () {
  // declare dataLayer
  function Consent() {
    _classCallCheck(this, Consent);
    this.init = this.init.bind(this);
    this.handleConsentUpdate = this.handleConsentUpdate.bind(this);
    this.checkConsentBannerInteraction = this.checkConsentBannerInteraction.bind(this);
    this.gtag = this.gtag.bind(this);
    this.recallConsent = this.recallConsent.bind(this);
    this.logConsent = this.logConsent.bind(this);
  }
  // methods
  return _createClass(Consent, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              window.Shopify.loadFeatures([{
                name: 'consent-tracking-api',
                version: '0.1'
              }], function (error) {
                if (error) {
                  console.error('Error loading features: ', error);
                  return;
                }
                console.log('Consent tracking API loaded');
                _this.initConsentComponent();
              });
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "initConsentComponent",
    value: function () {
      var _initConsentComponent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this2 = this;
        var recallConsentElement;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              window.dataLayer = window.dataLayer || [];
              document.addEventListener('visitorConsentCollected', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _this2.handleConsentUpdate('update');
                    case 1:
                      return _context2.a(2);
                  }
                }, _callee2);
              })));
              recallConsentElement = document.getElementById('recall-consent');
              if (recallConsentElement) {
                recallConsentElement.addEventListener('click', function (event) {
                  event.preventDefault();
                  _this2.recallConsent();
                });
              }
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      function initConsentComponent() {
        return _initConsentComponent.apply(this, arguments);
      }
      return initConsentComponent;
    }()
  }, {
    key: "handleConsentUpdate",
    value: function () {
      var _handleConsentUpdate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(state) {
        var visitorConsent, consent;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 1:
              visitorConsent = _context4.v;
              consent = {
                functionality_storage: visitorConsent.preferences === 'yes' ? 'granted' : 'granted',
                analytics_storage: visitorConsent.analytics === 'yes' ? 'granted' : 'denied',
                personalization_storage: visitorConsent.analytics === 'yes' ? 'granted' : 'denied',
                ad_storage: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
                ad_user_data: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
                ad_personalization: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
                wait_for_update: 3000
              };
              this.gtag('consent', state, consent);
              // set local Storage for consent settings for further use on other pages or after page
              localStorage.setItem('consentSettings', JSON.stringify(consent));
              this.logConsent(consent);
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function handleConsentUpdate(_x) {
        return _handleConsentUpdate.apply(this, arguments);
      }
      return handleConsentUpdate;
    }() /* eslint-disable */
  }, {
    key: "checkConsentBannerInteraction",
    value: (function () {
      var _checkConsentBannerInteraction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var visitorConsent;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 1:
              visitorConsent = _context5.v;
              if (!(visitorConsent.preferences === '' && visitorConsent.analytics === '' && visitorConsent.marketing === '')) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2, false);
            case 2:
              return _context5.a(2, true);
          }
        }, _callee5);
      }));
      function checkConsentBannerInteraction() {
        return _checkConsentBannerInteraction.apply(this, arguments);
      }
      return checkConsentBannerInteraction;
    }()
    /* eslint-disable */
    /* eslint-disable */
    )
  }, {
    key: "gtag",
    value: function gtag() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      window.dataLayer.push(arguments);
    }
    /* eslint-enable */
    /* eslint-disable */
  }, {
    key: "recallConsent",
    value: (function () {
      var _recallConsent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              window.privacyBanner.showPreferences();
            case 1:
              return _context6.a(2);
          }
        }, _callee6);
      }));
      function recallConsent() {
        return _recallConsent.apply(this, arguments);
      }
      return recallConsent;
    }() /* eslint-disable */)
  }, {
    key: "logConsent",
    value: (function () {
      var _logConsent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(consentSettings) {
        var _localStorage$getItem, userId, _t, _t2;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _context7.p = 0;
              if (!((_localStorage$getItem = localStorage.getItem('userId')) !== null && _localStorage$getItem !== void 0)) {
                _context7.n = 1;
                break;
              }
              _t = _localStorage$getItem;
              _context7.n = 3;
              break;
            case 1:
              _context7.n = 2;
              return this.generateRandomHash();
            case 2:
              _t = _context7.v;
            case 3:
              userId = _t;
              localStorage.setItem('userId', userId);
              /* TODO: Add endpoint to log the users preferences for more compliance
                const logData = {
                user: USER_HERE,
                consentSettings,
                }
                       const response = await fetch('https://my-url/api/my-endpoint', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(data),
                });
                       if (!response.ok) {
                  throw new Error('Failed to log consent');
                }
                       const data = await response.json();
                console.log('Consent logged successfully: ', data);
                       COMMENT FOR ENDPOINT + DATABASE
                       When this event is recieved in the endpoint, the backend should first look at the website the request is coming from.
                If the request is coming from a website that is not allowed in our database, the request should be denied.
                This is to prevent unauthorized websites from logging consent settings, and to only allow websites that use our services to log consent settings.
                       After verifying the website, the backend should log the user's consent settings to a database
                If the user does not exist in the database, create a new entry for the user with the consent settings
                If the user exists in the database, update the user's consent settings with the new values
                       Database strucutre should be relational and could look like this:
                Each user / visitor belongs to a shop, and each shop can have multiple users / visitors
                Each user / visitor can have multiple consent settings
                       model: Shop
                       id | name | url | created_at | updated_at | user[]
                ---------------------------------------------------
                1  | Shop1| url1| 2021-09-01 | 2021-09-01 | [User1, User2, User3]
                       model: User
                       User | Functionality | Analytics | Personalization | Ad Storage | Ad User Data | Ad Personalization | created_at | updated_at | shop_id
                -------------------------------------------------------------------------------------------------------
                User1|    granted    |  granted  |     granted     |   granted  |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
                User2|    granted    |  denied   |     granted     |   denied   |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
                User3|    granted    |  granted  |     granted     |   granted  |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
                User4|    granted    |  denied   |     granted     |   denied   |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
                User5|    granted    |  granted  |     granted     |   granted  |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
                User6|    granted    |  denied   |     granted     |   denied   |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
              */
              _context7.n = 5;
              break;
            case 4:
              _context7.p = 4;
              _t2 = _context7.v;
              console.error('Error logging consent: ', _t2);
            case 5:
              return _context7.a(2);
          }
        }, _callee7, this, [[0, 4]]);
      }));
      function logConsent(_x2) {
        return _logConsent.apply(this, arguments);
      }
      return logConsent;
    }())
  }, {
    key: "generateRandomHash",
    value: function () {
      var _generateRandomHash = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var randomHash;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              randomHash = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
              return _context8.a(2, randomHash);
          }
        }, _callee8);
      }));
      function generateRandomHash() {
        return _generateRandomHash.apply(this, arguments);
      }
      return generateRandomHash;
    }()
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/Geolocator/Geolocator.ts":
/*!***************************************************************!*\
  !*** ./resources/scripts/components/Geolocator/Geolocator.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Geolocator)
/* harmony export */ });
/* harmony import */ var _utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/CookieMethods */ "./resources/scripts/utils/CookieMethods.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var Geolocator = /*#__PURE__*/function (_HTMLElement) {
  function Geolocator() {
    var _this;
    _classCallCheck(this, Geolocator);
    _this = _callSuper(this, Geolocator);
    _defineProperty(_this, "countryData", void 0);
    _defineProperty(_this, "url", window.location.href);
    _this.countryData = window.countryData;
    // bind the methods to the class
    _this.getSelectedCountry = _this.getSelectedCountry.bind(_this);
    _this.getVisitorCountry = _this.getVisitorCountry.bind(_this);
    _this.showGeoPopup = _this.showGeoPopup.bind(_this);
    _this.handleClickedStayButton = _this.handleClickedStayButton.bind(_this);
    _this.handleClickedRedirectButton = _this.handleClickedRedirectButton.bind(_this);
    _this.checkUrlForParam = _this.checkUrlForParam.bind(_this);
    return _this;
  }
  _inherits(Geolocator, _HTMLElement);
  return _createClass(Geolocator, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var editionGeoCookie, editionGeoSwitchCookie, _window, countryData, selectedCountry, visitorCountry, visitorCountryIsInCountryData, primaryCountryDataInCountryData, visitorCountryDataInCountryData;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.checkUrlForParam();
              editionGeoCookie = (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.getCookie)('edition-geocookie');
              editionGeoSwitchCookie = (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.getCookie)('edition-geoswitch');
              if (!(editionGeoCookie || editionGeoSwitchCookie || Shopify.designMode === true)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _window = window, countryData = _window.countryData;
              selectedCountry = this.getSelectedCountry();
              _context.n = 2;
              return this.getVisitorCountry();
            case 2:
              visitorCountry = _context.v;
              if (!(selectedCountry.countryCode === visitorCountry.handle)) {
                _context.n = 3;
                break;
              }
              _context.n = 6;
              break;
            case 3:
              visitorCountryIsInCountryData = countryData.some(function (country) {
                return country.countryCode === visitorCountry.handle;
              });
              if (visitorCountryIsInCountryData) {
                _context.n = 5;
                break;
              }
              primaryCountryDataInCountryData = countryData.find(function (country) {
                return country.primaryCountry === true;
              });
              if (!(selectedCountry.countryCode === primaryCountryDataInCountryData.countryCode)) {
                _context.n = 4;
                break;
              }
              return _context.a(2);
            case 4:
              console.log(primaryCountryDataInCountryData, 'primaryCountryDataInCountryData');
              this.showGeoPopup(primaryCountryDataInCountryData);
              _context.n = 6;
              break;
            case 5:
              visitorCountryDataInCountryData = countryData.find(function (country) {
                return country.countryCode === visitorCountry.handle;
              });
              this.showGeoPopup(visitorCountryDataInCountryData);
            case 6:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "getSelectedCountry",
    value: function getSelectedCountry() {
      var countryDataArray = this.countryData;
      var selectedCountry = countryDataArray.find(function (country) {
        return country.locale === Shopify.locale;
      });
      return selectedCountry;
    }
  }, {
    key: "getVisitorCountry",
    value: function () {
      var _getVisitorCountry = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var response, data, visitorCountry;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return fetch('/browsing_context_suggestions.json');
            case 1:
              response = _context2.v;
              _context2.n = 2;
              return response.json();
            case 2:
              data = _context2.v;
              visitorCountry = data.detected_values.country;
              this.setAttribute('data-visitor-country', visitorCountry.handle);
              return _context2.a(2, visitorCountry);
          }
        }, _callee2, this);
      }));
      function getVisitorCountry() {
        return _getVisitorCountry.apply(this, arguments);
      }
      return getVisitorCountry;
    }()
  }, {
    key: "showGeoPopup",
    value: function showGeoPopup(countryObject) {
      var _this2 = this;
      this.classList.remove('tw-z-[-1]');
      this.classList.add('tw-z-[100]');
      setTimeout(function () {
        _this2.classList.add('!tw-opacity-100');
      }, 500);
      var layout = this.dataset.layout;
      if (layout === 'primary') {
        var img = this.querySelector('#geolocator-flag');
        var heading = this.querySelector('#geolocator-heading');
        var richtext = this.querySelector('#geolocator-richtext');
        var buttonRedirect = this.querySelector('#geolocator-button-redirect');
        var buttonStay = this.querySelector('#geolocator-button-stay');
        if (img) {
          img.src = countryObject.flag;
        }
        heading.innerHTML = countryObject.heading;
        richtext.innerText = countryObject.richtext;
        buttonRedirect.innerHTML = countryObject.button_one;
        buttonStay.innerHTML = countryObject.button_two;
        // If the user clicks the "redirect" button, redirect to the selected country or market
        buttonRedirect.addEventListener('click', this.handleClickedRedirectButton.bind(this, countryObject));
        // If the user clicks the "stay" button, set a cookie to prevent the popup from showing again for 10 minutes
        buttonStay.addEventListener('click', this.handleClickedStayButton.bind(this));
      } else {
        var _heading = this.querySelector('#geolocator-heading');
        var _richtext = this.querySelector('#geolocator-richtext');
        var _buttonStay = this.querySelector('#geolocator-button-stay');
        this.SortAndOrderCountries(countryObject);
        _heading.innerHTML = countryObject.heading;
        _richtext.innerHTML = countryObject.richtext;
        _buttonStay.innerHTML = countryObject.button_two;
        // If the user clicks the "stay" button, set a cookie to prevent the popup from showing again for 10 minutes
        _buttonStay.addEventListener('click', this.handleClickedStayButton.bind(this));
      }
    }
  }, {
    key: "handleClickedStayButton",
    value: function handleClickedStayButton() {
      var _this3 = this;
      this.classList.remove('tw-opacity-100');
      this.classList.add('tw-opacity-0');
      (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)('edition-geocookie', 'true', 10);
      setTimeout(function () {
        _this3.remove();
      }, 1000);
    }
  }, {
    key: "handleClickedRedirectButton",
    value: function handleClickedRedirectButton(countryObject) {
      this.remove();
      var storeType = countryObject.type;
      if (storeType === 'Country') {
        var redirectUrl = countryObject.link;
        window.location.href = redirectUrl;
      } else if (storeType === 'Market') {
        var code = countryObject.countryCode;
        var countryLocale = countryObject.locale;
        this.updateLocalization(code, countryLocale);
      }
    }
  }, {
    key: "checkUrlForParam",
    value: function checkUrlForParam() {
      if (this.url.includes('?edition-geoswitch')) {
        (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)('edition-geoswitch', 'true', 10);
      }
    }
  }, {
    key: "SortAndOrderCountries",
    value: function SortAndOrderCountries(countryObject) {
      var currentCountryListHolder = this.querySelector('#geolocator-country-list');
      var currentCountryList = Array.from(currentCountryListHolder.querySelectorAll('.geolocator_country'));
      // Each geolocator_country has a data-locale attribute. Sort the currentCountryList based on the data-locale attribute so the country that has the same locale as the countryObject is first in the list
      currentCountryList.sort(function (a, b) {
        if (a.dataset.locale === countryObject.locale) {
          return -1;
        }
        if (b.dataset.locale === countryObject.locale) {
          return 1;
        }
        return 0;
      });
      // Add the sorted list back to the DOM
      currentCountryList.forEach(function (country) {
        currentCountryListHolder.appendChild(country);
      });
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "updateLocalization",
    value: function updateLocalization(countryCode, countryLocale) {
      var randomFormId = Math.random().toString(36).substring(7);
      var formHtml = "\n    <form id=\"".concat(randomFormId, "\" action=\"/localization\" method=\"POST\" hidden>\n      <input name=\"_method\" value=\"PUT\">\n      <input name=\"country_code\" value=\"").concat(countryCode, "\">\n      <input name=\"language_code\" value=\"").concat(countryLocale, "\">\n    </form>\n  ");
      document.body.insertAdjacentHTML('beforeend', formHtml);
      var form = document.getElementById(randomFormId);
      form.submit();
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/MultistoreSwitcher/MultistoreSwitcher.ts":
/*!*******************************************************************************!*\
  !*** ./resources/scripts/components/MultistoreSwitcher/MultistoreSwitcher.ts ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ MultistoreSwitcher)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MultistoreSwitcher = /*#__PURE__*/function (_HTMLElement) {
  function MultistoreSwitcher() {
    var _this;
    _classCallCheck(this, MultistoreSwitcher);
    _this = _callSuper(this, MultistoreSwitcher);
    _defineProperty(_this, "countryData", void 0);
    _this.countryData = window.countryData;
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.handleSwitchClick = _this.handleSwitchClick.bind(_this);
    return _this;
  }
  _inherits(MultistoreSwitcher, _HTMLElement);
  return _createClass(MultistoreSwitcher, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.addEventListener('click', this.handleSwitchClick);
      document.addEventListener('click', this.handleDocumentClick);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.removeEventListener('click', this.handleSwitchClick);
      document.removeEventListener('click', this.handleDocumentClick);
    }
  }, {
    key: "handleSwitchClick",
    value: function handleSwitchClick(event) {
      var target = event.target;
      var button = target.closest('.language-switcher-button');
      var switchBtn = target.closest('.switcher-btn');
      if (button) {
        event.preventDefault();
        this.toggleDropdown(button);
      }
      if (switchBtn) {
        event.preventDefault();
        this.submitLanguageForm(switchBtn, this.countryData[0]);
      }
    }
  }, {
    key: "handleDocumentClick",
    value: function handleDocumentClick(event) {
      var target = event.target;
      if (!this.contains(target)) {
        this.closeAllDropdowns();
      }
    }
  }, {
    key: "toggleDropdown",
    value: function toggleDropdown(button) {
      var switcher = button.closest('.language-switcher');
      if (!switcher) return;
      var dropdown = switcher.querySelector('.language-dropdown-menu');
      if (!dropdown) return;
      var isHidden = dropdown.classList.contains('tw-hidden');
      button.setAttribute('aria-expanded', String(isHidden));
      dropdown.classList.toggle('tw-hidden');
      this.closeOtherDropdowns(switcher);
    }
  }, {
    key: "closeAllDropdowns",
    value: function closeAllDropdowns() {
      this.querySelectorAll('.language-switcher').forEach(function (switcher) {
        var button = switcher.querySelector('.language-switcher-button');
        var dropdown = switcher.querySelector('.language-dropdown-menu');
        if (button && dropdown) {
          button.setAttribute('aria-expanded', 'false');
          dropdown.classList.add('tw-hidden');
        }
      });
    }
  }, {
    key: "closeOtherDropdowns",
    value: function closeOtherDropdowns(currentSwitcher) {
      this.querySelectorAll('.language-switcher').forEach(function (switcher) {
        if (switcher !== currentSwitcher) {
          var button = switcher.querySelector('.language-switcher-button');
          var dropdown = switcher.querySelector('.language-dropdown-menu');
          if (button && dropdown) {
            button.setAttribute('aria-expanded', 'false');
            dropdown.classList.add('tw-hidden');
          }
        }
      });
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "submitLanguageForm",
    value: function submitLanguageForm(button, countryObject) {
      var countryCode = button.getAttribute('data-country-code');
      var languageCode = button.getAttribute('data-language-code');
      var url = button.getAttribute('data-url-code');
      var storeType = countryObject.type;
      var StoreUrl = url;
      if (storeType === 'Country') {
        var redirectUrl = "https://".concat(StoreUrl, "/");
        window.location.href = redirectUrl;
      } else if (storeType === 'Market') {
        if (countryCode && languageCode) {
          var form = document.createElement('form');
          form.hidden = true;
          form.method = 'POST';
          form.action = '/localization';
          var methodInput = document.createElement('input');
          methodInput.name = '_method';
          methodInput.value = 'PUT';
          var countryInput = document.createElement('input');
          countryInput.name = 'country_code';
          countryInput.value = countryCode;
          var languageInput = document.createElement('input');
          languageInput.name = 'language_code';
          languageInput.value = languageCode;
          form.appendChild(methodInput);
          form.appendChild(countryInput);
          form.appendChild(languageInput);
          document.body.appendChild(form);
          form.submit();
        }
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/*
______________________________________________________________________________________

Render the snippet in a section you would like to display the language switcher on.
  
  For header view
  {% render 'multistore-switcher' %}

  For footer view
  {% render 'multistore-switcher' view: 'footer' %}

  For mobile menu view
  {% render 'multistore-switcher' view: 'mobile' %}

______________________________________________________________________________________

settings_schema.json

{
  "name": "Language Switcher",
  "settings": [
    {
      "type": "header",
      "content": "Language Switcher"
    },
    {
      "type": "text",
      "id": "language_switcher_countries",
      "label": "Country Code List (comma separated)",
      "default": "DK,SE"
    },
    {
      "type": "text",
      "id": "language_switcher_locales",
      "label": "Locales (comma separated)",
      "default": "da,sv"
    },
    {
      "type": "text",
      "id": "language_switcher_labels",
      "label": "Labels (comma separated)",
      "default": "Dansk,Svenska"
    }
  ]
},
______________________________________________________________________________________
*/


/***/ }),

/***/ "./resources/scripts/components/OptionFieldsets/OptionFieldsets.ts":
/*!*************************************************************************!*\
  !*** ./resources/scripts/components/OptionFieldsets/OptionFieldsets.ts ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ OptionFieldsets)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var OptionFieldsets = /*#__PURE__*/function (_HTMLElement) {
  function OptionFieldsets() {
    var _this;
    _classCallCheck(this, OptionFieldsets);
    _this = _callSuper(this, OptionFieldsets);
    _defineProperty(_this, "optionFieldsets", void 0);
    _defineProperty(_this, "addToCartBtn", void 0);
    _defineProperty(_this, "btnTextEl", void 0);
    _defineProperty(_this, "productForm", void 0);
    _defineProperty(_this, "addToCartContainer", void 0);
    _defineProperty(_this, "addToCartAlert", void 0);
    _defineProperty(_this, "productMinMax", void 0);
    _this.checkOptions = _this.checkOptions.bind(_this);
    return _this;
  }
  _inherits(OptionFieldsets, _HTMLElement);
  return _createClass(OptionFieldsets, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.optionFieldsets = this.querySelectorAll('fieldset[data-index^="option"]');
      this.addToCartBtn = document.getElementById('AddToCart');
      this.addToCartContainer = document.querySelector('.add_to_cart_holder');
      this.btnTextEl = this.addToCartBtn.querySelector('.single-add-to-cart-button--text');
      this.productForm = document.querySelector('.product_price_from');
      this.productMinMax = document.querySelector('.product_min_max');
      this.addToCartAlert = document.querySelectorAll('.add_to_cart_alert');
      if (!this.addToCartBtn || !this.optionFieldsets.length) {
        return;
      }
      this.optionFieldsets.forEach(function (fieldset) {
        var radios = fieldset.querySelectorAll('input[type="radio"]');
        radios.forEach(function (radio) {
          radio.addEventListener('product:variant-change', function () {
            return _this2.checkOptions();
          });
        });
      });
      document.addEventListener('product:variant-change', function () {
        return _this2.checkOptions();
      });
      this.checkOptions();
      this.addToCartContainer.addEventListener('click', function () {
        _this2.AddToCartAlert();
      });
    }
  }, {
    key: "AddToCartAlert",
    value: function AddToCartAlert() {
      if (this.addToCartBtn.disabled) {
        this.addToCartAlert.forEach(function (alertEl) {
          alertEl.classList.add('active');
          setTimeout(function () {
            alertEl.classList.remove('active');
          }, 4000);
        });
      }
    }
  }, {
    key: "checkOptions",
    value: function checkOptions() {
      var allSelected = true;
      if (this.productForm) {
        this.productForm.style.display = 'none';
      }
      if (this.productMinMax && this.productForm.style.display === 'none') {
        this.productMinMax.style.display = 'block';
      }
      this.btnTextEl.textContent = this.addToCartBtn.getAttribute('data-select-options');
      this.addToCartBtn.disabled = true;
      this.optionFieldsets.forEach(function (fieldset) {
        if (!fieldset.querySelector('input[type="radio"]:checked')) {
          allSelected = false;
        }
      });
      if (allSelected) {
        var preOrderText = this.addToCartBtn.getAttribute('data-pre-order-text');
        var addToCartText = this.addToCartBtn.getAttribute('data-add-to-cart');
        var buttonText = preOrderText && preOrderText.trim() !== '' ? preOrderText : addToCartText;
        this.btnTextEl.textContent = buttonText;
        this.addToCartBtn.disabled = false;
        if (this.productForm) {
          this.productForm.style.display = 'block';
        }
        if (this.productMinMax && this.productForm.style.display === 'block') {
          this.productMinMax.style.display = 'none';
        }
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/ShowMoreVariants/ShowMoreVariants.ts":
/*!***************************************************************************!*\
  !*** ./resources/scripts/components/ShowMoreVariants/ShowMoreVariants.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ShowMoreVariants)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ShowMoreVariants = /*#__PURE__*/function (_HTMLElement) {
  function ShowMoreVariants() {
    var _this;
    _classCallCheck(this, ShowMoreVariants);
    _this = _callSuper(this, ShowMoreVariants);
    _defineProperty(_this, "unikaOptions", Array.from(document.querySelectorAll('.unika-option')));
    _this.addEventListeners = _this.addEventListeners.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }
  _inherits(ShowMoreVariants, _HTMLElement);
  return _createClass(ShowMoreVariants, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.addEventListeners();
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this2 = this;
      this.addEventListener('click', function (event) {
        event.preventDefault();
        _this2.handleClick();
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      this.unikaOptions.forEach(function (option) {
        var parent = option.closest('.unika-parent.tw-hidden');
        if (parent) {
          parent.classList.remove('tw-hidden');
        }
      });
      this.remove();
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/Slider/Slider.ts":
/*!*******************************************************!*\
  !*** ./resources/scripts/components/Slider/Slider.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ SliderSection)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SliderSection = /*#__PURE__*/function (_HTMLElement) {
  function SliderSection() {
    var _this;
    _classCallCheck(this, SliderSection);
    _this = _callSuper(this, SliderSection);
    _defineProperty(_this, "autoSlideInterval", null);
    _defineProperty(_this, "autoSlideTimeout", null);
    _defineProperty(_this, "isUserInteracting", false);
    var slider = _this;
    var scrollContainer = slider.closest('.scroll-container');
    var sliderCards = Array.from(slider.querySelectorAll('.slide'));
    var sliderCardsWidth = sliderCards.length > 0 ? sliderCards[0].offsetWidth + 12 : 0;
    var sliderBtns = Array.from(scrollContainer.querySelectorAll('.sliderbtn'));
    sliderBtns.forEach(function (sliderBtn) {
      sliderBtn.addEventListener('click', function () {
        var direction = sliderBtn.getAttribute('data-id');
        if (direction === 'right') {
          slider.scrollLeft += sliderCardsWidth;
        } else if (direction === 'left') {
          slider.scrollLeft -= sliderCardsWidth;
        }
      });
    });
    if (_this.getAttribute('data-type-auto-slide') === 'true') {
      _this.startAutoSlide(slider, sliderCardsWidth);
      scrollContainer.addEventListener('mouseenter', function () {
        _this.stopAutoSlide();
        _this.isUserInteracting = true;
      });
      scrollContainer.addEventListener('mouseleave', function () {
        _this.isUserInteracting = false;
        _this.startAutoSlide(slider, sliderCardsWidth);
      });
      scrollContainer.addEventListener('scroll', function () {
        if (!_this.isUserInteracting) {
          _this.stopAutoSlide();
          clearTimeout(_this.autoSlideTimeout);
          _this.autoSlideTimeout = setTimeout(function () {
            if (!_this.isUserInteracting) {
              _this.startAutoSlide(slider, sliderCardsWidth);
            }
          }, 2000);
        }
      });
    }
    return _this;
  }
  _inherits(SliderSection, _HTMLElement);
  return _createClass(SliderSection, [{
    key: "startAutoSlide",
    value: function startAutoSlide(sliderElement, slideWidth) {
      var slideDelay = parseInt(this.getAttribute('data-slide-delay') || '3000', 10); // Use delay from attribute or default to 3000ms (3 seconds)
      this.autoSlideInterval = setInterval(function () {
        var maxScrollLeft = sliderElement.scrollWidth - sliderElement.clientWidth;
        if (sliderElement.scrollLeft + slideWidth >= maxScrollLeft) {
          sliderElement.scrollLeft = 0;
        } else {
          sliderElement.scrollLeft += slideWidth;
        }
      }, slideDelay);
    }
  }, {
    key: "stopAutoSlide",
    value: function stopAutoSlide() {
      if (this.autoSlideInterval) {
        clearInterval(this.autoSlideInterval);
        this.autoSlideInterval = null;
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.stopAutoSlide();
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/Video/Video.ts":
/*!*****************************************************!*\
  !*** ./resources/scripts/components/Video/Video.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Video)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Video = /*#__PURE__*/function (_HTMLElement) {
  function Video() {
    var _this;
    _classCallCheck(this, Video);
    _this = _callSuper(this, Video);
    _defineProperty(_this, "container", void 0);
    _defineProperty(_this, "video", void 0);
    _defineProperty(_this, "controlBtnPlay", void 0);
    _defineProperty(_this, "controlBtnPause", void 0);
    _defineProperty(_this, "cover", void 0);
    _this.playVideo = _this.playVideo.bind(_this);
    _this.updateButton = _this.updateButton.bind(_this);
    return _this;
  }
  _inherits(Video, _HTMLElement);
  return _createClass(Video, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.container = this.querySelector('.custom-video-container');
      this.video = this.container.querySelector('#video');
      this.controlBtnPlay = this.querySelector('#video-control-play');
      this.controlBtnPause = this.querySelector('#video-control-pause');
      this.cover = this.container.querySelector('.video-cover');
      if (!this.video || !this.controlBtnPlay || !this.controlBtnPause) return;
      this.container.addEventListener('click', this.playVideo);
      this.container.addEventListener('mouseenter', function () {
        if (!_this2.video.paused) {
          _this2.controlBtnPause.classList.remove('hidden');
        }
      });
      this.container.addEventListener('mouseleave', function () {
        if (!_this2.video.paused) {
          _this2.controlBtnPause.classList.add('hidden');
        }
      });
      this.video.addEventListener('play', this.updateButton);
      this.video.addEventListener('pause', this.updateButton);
      this.updateButton();
    }
  }, {
    key: "playVideo",
    value: function playVideo() {
      if (this.video.paused) {
        this.video.play();
      } else {
        this.video.pause();
      }
      this.updateButton();
    }
  }, {
    key: "updateButton",
    value: function updateButton() {
      if (this.video.paused) {
        this.controlBtnPlay.classList.remove('hidden');
        this.controlBtnPause.classList.add('hidden');
        if (this.cover) {
          this.cover.classList.remove('hidden');
        }
      } else {
        this.controlBtnPlay.classList.add('hidden');
        this.controlBtnPause.classList.add('hidden');
        if (this.cover) {
          this.cover.classList.add('hidden');
        }
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/utils/CookieMethods.ts":
/*!**************************************************!*\
  !*** ./resources/scripts/utils/CookieMethods.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "deleteCookie": () => (/* binding */ deleteCookie),
/* harmony export */   "getCookie": () => (/* binding */ getCookie),
/* harmony export */   "setCookie": () => (/* binding */ setCookie)
/* harmony export */ });
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function setCookie(name, value, minutes) {
  document.cookie = "".concat(name, "=").concat(value, ";max-age=").concat(minutes * 60, ";path=/");
}
function getCookie(name) {
  var cookies = document.cookie.split(';');
  var foundCookie = cookies.find(function (cookie) {
    var _cookie$split = cookie.split('='),
      _cookie$split2 = _slicedToArray(_cookie$split, 1),
      cookieName = _cookie$split2[0];
    return cookieName.trim() === name;
  });
  return foundCookie === null || foundCookie === void 0 ? void 0 : foundCookie.split('=')[1];
}
function deleteCookie(name) {
  document.cookie = "".concat(name, "=;max-age=0;path=/");
}

/***/ }),

/***/ "./resources/styles/app.css":
/*!**********************************!*\
  !*** ./resources/styles/app.css ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/shopify-theme/assets/edition": 0,
/******/ 			"shopify-theme/assets/edition": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkfloofers_shop"] = self["webpackChunkfloofers_shop"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/app.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/styles/app.css")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;